/**
 * Date and Time Utilities
 * Centralized date/time formatting and encoding functions
 */

/**
 * Generates an encoded timestamp (base64) for API requests
 * Used across cart, wishlist, address, and payment APIs
 * 
 * @returns Base64 encoded current datetime string
 * @example
 * const d = getEncodedTimestamp();
 * // Result: "TW9uIE5vdiAyNSAyMDI1IDEyOjMwOjQ1IEdNVCswMDAwIChhbGxvY2F0ZWQpOiBTdW0gTm92IDI1IDIwMjUgMTI6MzA6NDUgR01UKzAwMDAg"
 */
export const getEncodedTimestamp = (): string => {
  return btoa(new Date().toString());
};

/**
 * Gets current date in formatted string
 * @returns Formatted current date
 */
export const getCurrentDate = (): string => {
  return new Date().toString();
};

/**
 * Gets timestamp in milliseconds
 * @returns Current timestamp in ms
 */
export const getTimestampMs = (): number => {
  return new Date().getTime();
};
